module.exports = __webpack_public_path__ + "img/Clothing-Underwearstyle.9f12a123.jpg";